<div class="company-form">
  <!-- Search Step -->
  <ng-container *ngIf="companyStep === 'search'">
    <div class="form-row">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Legal Name</mat-label>
        <input
          matInput
          type="text"
          [formControl]="legalNameControl"
          [matAutocomplete]="autoCompanySearch"
          (input)="onLegalNameInput()"
          required
        />
        <mat-autocomplete
          #autoCompanySearch="matAutocomplete"
          [displayWith]="displayCompanySearch"
          (optionSelected)="onCompanySearchSelect($event.option.value)"
          class="company-search-panel"
        >
          <!-- Company results -->
          <ng-container *ngIf="companySearchResults$ | async as results">
            <mat-optgroup *ngIf="results.length">
              <div class="search-header">
                <span class="header-name">Company</span>
                <span class="header-country">Country</span>
                <span class="header-count"># Articles</span>
              </div>
              <mat-option *ngFor="let hit of results" [value]="hit">
                <div class="search-result-row">
                  <span class="result-name">{{ hit.entity.name }}</span>
                  <span class="result-country">{{
                    hit.entity.country?.alpha_id | uppercase
                  }}</span>
                  <span class="result-count">{{ hit.count ?? '-' }}</span>
                </div>
              </mat-option>
            </mat-optgroup>
          </ng-container>

          <!-- Free text option -->
          <mat-option
            *ngIf="legalNameText.length >= 3"
            [value]="{ _freeText: legalNameText }"
            class="free-text-option"
          >
            <mat-icon>edit</mat-icon>
            Set "{{ legalNameText }}" as new company
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <div class="form-row" *ngIf="isNewCompany">
      <mat-form-field appearance="outline">
        <mat-label>Website</mat-label>
        <input
          matInput
          type="url"
          [(ngModel)]="website"
          (ngModelChange)="emitSearchState()"
          [readonly]="enriching"
          required
        />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Country</mat-label>
        <input
          matInput
          type="text"
          [formControl]="countryControl"
          [matAutocomplete]="autoCountry"
          required
        />
        <mat-autocomplete
          #autoCountry="matAutocomplete"
          [displayWith]="displayGroupingEntity"
          (optionSelected)="emitSearchState()"
        >
          <mat-option
            *ngFor="let country of filteredCountries | async"
            [value]="country"
          >
            {{ country.name }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <div class="enrichment-error" *ngIf="enrichmentError">
      <mat-icon>error_outline</mat-icon>
      <div class="enrichment-error-body">
        <div class="err-title">
          We couldn't enrich this company automatically
        </div>
        {{ enrichmentError }}
        <span class="fill-manually-link" (click)="skipToForm()">
          Fill Manually
        </span>
      </div>
    </div>
  </ng-container>

  <!-- Form Step -->
  <ng-container *ngIf="companyStep === 'form'">
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Legal Name</mat-label>
        <input matInput type="text" [value]="legalName" readonly />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Sector</mat-label>
        <input
          matInput
          type="text"
          [formControl]="sectorControl"
          [matAutocomplete]="autoSector"
          (input)="emitValidity()"
          required
        />
        <mat-autocomplete
          #autoSector="matAutocomplete"
          [displayWith]="displayGroupingEntity"
          (optionSelected)="emitValidity()"
        >
          <mat-option
            *ngFor="let sector of filteredSectors | async"
            [value]="sector"
          >
            {{ sector.name }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Website</mat-label>
        <input matInput type="url" [(ngModel)]="website" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>ISIN</mat-label>
        <input matInput type="text" [(ngModel)]="isin" />
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Country</mat-label>
        <input
          matInput
          type="text"
          [formControl]="countryControl"
          [matAutocomplete]="autoCountryForm"
          (input)="emitValidity()"
          required
        />
        <mat-autocomplete
          #autoCountryForm="matAutocomplete"
          [displayWith]="displayGroupingEntity"
          (optionSelected)="emitValidity()"
        >
          <mat-option
            *ngFor="let country of filteredCountries | async"
            [value]="country"
          >
            {{ country.name }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>City</mat-label>
        <input matInput type="text" [(ngModel)]="city" />
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>CEO Name</mat-label>
        <input matInput type="text" [(ngModel)]="ceoName" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Message</mat-label>
        <input matInput type="text" [(ngModel)]="message" />
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Surface Forms</mat-label>
        <mat-chip-list #chipList>
          <mat-chip
            *ngFor="let form of surfaceForms"
            [removable]="true"
            (removed)="removeSurfaceForm(form)"
          >
            {{ form }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
          <input
            matInput
            [matChipInputFor]="chipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="true"
            (matChipInputTokenEnd)="addSurfaceForm($event)"
          />
        </mat-chip-list>
      </mat-form-field>
    </div>
  </ng-container>
</div>
